import CoreMessageDispatcher from '../controller/CoreMessageDispatcher';
import CoreEvents from '../events/CoreEvents';

const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(mdr, true);
    _dispatcher.on(CoreEvents.MODEL_CHANGED, mdr._update);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    _dispatcher.off(CoreEvents.MODEL_CHANGED, mdr._update);

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    let key;
    for (key in mdr.mapModelGetters) {
        if (mdr.mapModelGetters.hasOwnProperty(key)) {
            _setDataState(mdr, mdr.mapModelGetters[key], key);
        }
    }

    return mdr;
};

const _setDataState = (mdr, key, getterKey) => {
    if (!mdr.el) return;
    mdr.el.dataset[key] = mdr.model[getterKey];
};

const CoreBodyMediator = (el, model) => {
    const mdr = {
        el: el,
        model: model,
        mapModelGetters: {
            status: 'status',
            state: 'state'
        }
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {CoreBodyMediator};
export default CoreBodyMediator;
